import { Controller } from "stimulus";

// Segmented control for the Arquivos tab: toggles between "Enviados" (file
// manager) and "Emitidos" (issued documents). The Emitidos turbo-frame is
// lazy-loaded — it only fetches when its panel first becomes visible.
export default class extends Controller {
  static targets = ["seg", "panel"];
  static values = { mode: String };

  connect() {
    const savedMode = localStorage.getItem("files-tab:mode") || this.modeValue || "enviados";
    this.applyMode(savedMode);
  }

  switch(event) {
    this.applyMode(event.currentTarget.dataset.mode);
  }

  applyMode(mode) {
    localStorage.setItem("files-tab:mode", mode);
    this.segTargets.forEach((seg) => seg.setAttribute("aria-pressed", String(seg.dataset.mode === mode)));
    this.panelTargets.forEach((panel) => { panel.hidden = panel.dataset.mode !== mode; });
  }
}
